import { getApiErrorMessage } from "../../../../../utils/commonFunction";
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */

import { Button, Table, Form } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import ActiveDialogApi from "../../../../../../_metronic/_partials/widgets/alert/ActiveDialogApiCall";
import { EditVan } from "../franchise-canva";
import SVG from "react-inlinesvg";
import SnackBarTool from "../../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import {
  createFranchiseVanStatus,
  deleteContainer,
} from "../../../_redux/franchises/franchisesCrud";
import { fetchFranchisesVan } from "../../../_redux/franchises/franchisesActions";
import { initIds } from "../../../../../../_metronic/_partials/controls/RightPanel";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useIntl } from "react-intl";
import InactiveDialog from "../franchise-active-dialog/InactiveDialog";
import { CircularProgress, Switch } from "@mui/material";
import SiteModal from "../franchise-modal/SiteModal";
import { ContainerCanva } from "../franchise-canva/ContainerCanva";
import { fetchContainerFranchise } from "../../../_redux/container/containerAction";
import { EditContainerModal } from "../franchise-modal/EditContainerModal";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteDialogApi from "../franchise-active-dialog/DeleteDialog";
import Pagination from '@mui/material/Pagination';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { SortableHeader } from "./SortableHeader";
import { NO_SORT, nextSort, sortParams } from "./tableSort";

/**
 * Display label for under_maintenance boolean.
 *
 * @param {boolean|undefined|null} value
 * @returns {"Yes"|"No"}
 */
const formatUnderMaintenance = (value) => (value ? "Yes" : "No");

/**
 * Lists franchise containers with create, edit, and delete actions.
 *
 * @param {Object} props
 * @param {Object} props.permission - User permission flags
 * @param {Object} props.franchData - Franchise data context
 * @param {string|number} props.fraId - Franchise id
 * @returns {JSX.Element}
 */
export function Container({ permission, franchData, fraId }) {
  const intl = useIntl();
  // Use the dispatch hook to dispatch actions
  const dispatch = useDispatch();
  const init = ["kt_container_panel"];
  // Use state hook to manage snackbar state
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  // Use state hook to manage dialog state
  const [dialog, setDialog] = useState(false);
  const [dialogEdit, setDialogEdit] = useState({ check: false });
  const [deleteSites, setDeleteSite] = useState({ modal: false });
  const [toggleCheck, setToggleCheck] = useState(false);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(NO_SORT);
  const [search, setSearch] = useState({
    reference_unique_id: "",
    container_room_number: "",
    container_serial_number: "",
  });

  // Use the useSelector hook to access the state
  const { conLoading, vanLoading, containerList } = useSelector(
    (state) => ({
      conLoading: state.container.conLoading,
      vanLoading: state.franchise.vanLoading,
      containerList: state.container.containerFranchise,
    }),
    shallowEqual
  );
  useEffect(() => {
    if (dialog) initIds(init);
  }, [init, dialog]);

  // Event handler for changing the van status
  const handleChange = () => {
    setSnack({ call: false, type: "", message: "" });

    const data = {
      id: dialog.data.id,
      status: dialog.data.e ? 1 : 0,
    };
    // Call the createFranchiseVanStatus function to update the van status
    createFranchiseVanStatus(data)
      .then((res) => {
        if (res.data.success) {
          if (res.data.data?.statusChangeAllowed !== 1) {
            return;
          }
          // Dispatch an action to fetch updated van data
          dispatch(fetchFranchisesVan(dialog.data.franchise));
          setSnack({
            call: true,
            type: "success",
            message: res.data.message,
          });
        } else {
          setSnack({ call: true, type: "error", message: res.data.message });
        }
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });

    setDialog({ check: false });
  };
  /**
   * The container list request for the current page, search and sort.
   *
   * @returns {Object} Query params for fetchContainerFranchise
   */
  const buildQueryParams = () => ({
    pageNumber: page,
    pageSize: 20,
    franchise_id: fraId,
    ...sortParams(sort),
    ...(search?.reference_unique_id?.trim() && { reference_unique_id: search.reference_unique_id.trim() }),
    ...(search?.container_room_number?.trim() && { container_room_number: search.container_room_number.trim() }),
    ...(search?.container_serial_number?.trim() && { container_serial_number: search.container_serial_number.trim() }),
  });

  /** Run the search from page 1, keeping the current sort. */
  const handleSearch = () => {
    setPage(1);
    dispatch(fetchContainerFranchise({ ...buildQueryParams(), pageNumber: 1 }));
  };

  /** Clear the search fields and reload from page 1, keeping the current sort. */
  const clearSearch = () => {
    setSearch({
      reference_unique_id: "",
      container_room_number: "",
      container_serial_number: "",
    });
    setPage(1);
    dispatch(fetchContainerFranchise({
      pageNumber: 1,
      pageSize: 20,
      franchise_id: fraId,
      ...sortParams(sort),
    }));
  };

  /**
   * Toggle the sort on a column and reload from the first page, keeping the
   * current search.
   *
   * @param {string} field The API's sort_by value
   */
  const handleSort = (field) => {
    const next = nextSort(sort, field);
    setSort(next);
    setPage(1);
    dispatch(fetchContainerFranchise({
      ...buildQueryParams(),
      sort_by: undefined,
      sort_dir: undefined,
      ...sortParams(next),
      pageNumber: 1,
    }));
  };

  // Render the JSX for the component - fetch when container section is expanded
  useEffect(() => {
    if (toggleCheck) {
      dispatch(fetchContainerFranchise(buildQueryParams()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleCheck]);

  const handleDelete = (id) => {
    setSnack({ call: false, type: "", message: "" });
    deleteContainer({ id: id })
      .then((res) => {
        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setDeleteSite({ modal: false });
        dispatch(fetchContainerFranchise(buildQueryParams()));
      })
      .catch((err) => {
        setSnack({ call: true, type: "error", message: err });
        setDeleteSite({ modal: false });
      });
  };
  return (
    <>
      <div className="card card-custom  gutter-b mb-10">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center w-100 ">
            <h3 className="card-title p-0 m-0 ">
              <span className="font-weight-bolder text-dark">Container</span>
              <span>
                {toggleCheck ? (
                  <ExpandLessIcon
                    style={{
                      fontSize: "3rem",
                      margin: " 0 10px",
                      cursor: "pointer",
                    }}
                    onClick={() => setToggleCheck(!toggleCheck)}
                  />
                ) : (
                  <KeyboardArrowRightIcon
                    style={{
                      fontSize: "3rem",
                      margin: " 0 10px",
                      cursor: "pointer",
                    }}
                    onClick={() => setToggleCheck(!toggleCheck)}
                  />
                )}
              </span>
              {/* <Switch
                checked={toggleCheck}
                onChange={() => setToggleCheck(!toggleCheck)}
                color="primary"
                name="checkedB"
                inputProps={{ "aria-label": "primary checkbox" }}
              /> */}
            </h3>
            <div>
              {/* {permission?.setting_franchise?.create ||
              permission?.setting_franchise?.edit ? ( */}
              <Button
                variant="primary"
                size="sm"
                onClick={() => setDialog(true)}
              >
                Add Container
              </Button>
              {/* ) : (
                ""
              )} */}
            </div>
          </div>
          {toggleCheck && (
            <>
              <div className="mt-3 mb-3">
                <div className="font-weight-bolder text-dark mb-2">Filters</div>
                <div className="d-flex flex-wrap align-items-end">
                  <Form.Group className="mb-0 mr-4">
                    <Form.Label className="mb-1 small text-muted">Container number</Form.Label>
                    <Form.Control
                      size="sm"
                      className="rounded bg-light border-0"
                      value={search?.reference_unique_id ?? ""}
                      onChange={(e) => {
                        const value = e.target ? e.target.value : "";
                        setSearch((s) => ({ ...s, reference_unique_id: value }));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearch();
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-0 mr-4">
                    <Form.Label className="mb-1 small text-muted">Room number</Form.Label>
                    <Form.Control
                      size="sm"
                      className="rounded bg-light border-0"
                      value={search?.container_room_number ?? ""}
                      onChange={(e) => {
                        const value = e.target ? e.target.value : "";
                        setSearch((s) => ({ ...s, container_room_number: value }));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearch();
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-0 mr-4">
                    <Form.Label className="mb-1 small text-muted">Serial number</Form.Label>
                    <Form.Control
                      size="sm"
                      className="rounded bg-light border-0"
                      value={search?.container_serial_number ?? ""}
                      onChange={(e) => {
                        const value = e.target ? e.target.value : "";
                        setSearch((s) => ({ ...s, container_serial_number: value }));
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearch();
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-0">
                    <Form.Label className="mb-1 d-block">&nbsp;</Form.Label>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="primary"
                        size="sm"
                        className="rounded mr-2"
                        style={{ minHeight: "31px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded font-weight-bold border"
                        onClick={clearSearch}
                        style={{ backgroundColor: "#fff", color: "#000", minHeight: "31px" }}
                      >
                        Clear
                      </Button>
                    </div>
                  </Form.Group>
                </div>
              </div>
              {containerList?.list && containerList?.list?.length ? (
                <>
                  <Table responsive className="mt-5">
                    <thead>
                      <tr>
                        <SortableHeader
                          label="Unique ID"
                          field="reference_unique_id"
                          sort={sort}
                          onSort={handleSort}
                        />
                        <th>Container Name</th>
                        <th>Type</th>
                        <th>Floor</th>
                        <th>Site Name</th>
                        <th>Class Name</th>
                        <th>currently on site</th>
                        <th>Store vehicle</th>
                        <th>Vehicle access</th>
                        <th>Available from</th>
                        <th>Under maintenance</th>
                        <th style={{ width: "20px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {containerList?.list
                        ? containerList?.list.map((data, index) => (
                            <tr key={index}>
                              <td>{data.reference_unique_id}</td>
                              <td>{data.container_name + " sqft"}</td>
                              <td>{data.type}</td>
                              <td>{data.floor}</td>
                              <td>{data.site_name}</td>
                              <td>{data.class_name}</td>
                              <td>{data.currently_on_site}</td>
                              <td>{data.store_vehicle}</td>
                              <td>{data.vehicle_access}</td>
                              <td>
                                {data.available_from
                                  ? moment(data.available_from).format(
                                      "DD-MM-yyyy"
                                    )
                                  : ""}
                              </td>
                              <td>{formatUnderMaintenance(data.under_maintenance)}</td>

                              <td className="d-flex">
                                <span
                                  className="symbol-label ml-2 pointer"
                                  onClick={() =>
                                    setDialogEdit({ check: true, data: data })
                                  }
                                >
                                  <span className="svg-icon svg-icon-sm svg-icon-primary">
                                    <SVG
                                      className="h-25 align-self-end"
                                      title="Edit"
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/Design/Edit.svg"
                                      )}
                                    ></SVG>
                                  </span>
                                </span>
                                <span
                                  className="symbol-label  pointer"
                                  onClick={() =>
                                    setDeleteSite({
                                      modal: true,
                                      data: data?.id,
                                    })
                                  }
                                >
                                  <DeleteIcon />
                                </span>
                              </td>
                            </tr>
                          ))
                        : ""}
                    </tbody>
                  </Table>
                  <Pagination
                    count={Math.ceil(+containerList?.totalCount / 20)}
                    page={page}
                    onChange={(e, p) => {
                      setPage(p);
                      dispatch(
                        fetchContainerFranchise({
                          ...buildQueryParams(),
                          pageNumber: p,
                        })
                      );
                    }}
                    shape="rounded"
                  />
                </>
              ) : (
                <>
                  {conLoading ? (
                    <div className="text-center mt-8">
                      <CircularProgress />
                    </div>
                  ) : (
                    <div className="mt-4" style={{ textAlign: "center" }}>
                      <p>{intl.formatMessage({ id: "No.Record.Found" })}</p>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      {deleteSites.modal && (
        <DeleteDialogApi
          title={"Container"}
          handleChange={handleDelete}
          dialog={deleteSites}
          setDialog={setDeleteSite}
          deleteSite={true}
        />
      )}
      {dialogEdit.check && (
        <EditContainerModal
          dialogCanva={dialogEdit}
          setDialogCanva={setDialogEdit}
          fraId={fraId}
          listSort={sortParams(sort)}
        />
      )}
      {dialog && (
        <ContainerCanva
          dialogCanva={dialog}
          setDialogCanva={setDialog}
          fraId={fraId}
          listSort={sortParams(sort)}
        />
      )}
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </>
  );
}
